import { FaClock, FaMapMarkerAlt, FaUserTie, FaDollarSign, FaTags, FaBriefcase, FaCalendarAlt, FaPhone, FaUsers, FaEnvelope, FaAward, FaGraduationCap } from 'react-icons/fa';

// Function to render the appropriate icon based on the service name
export const renderIcon = (iconName) => {

  // Convert the service name to lowercase
  const lowercaseServiceName = iconName.toLowerCase();

  // Check the lowercase service name and return the corresponding icon component
  switch (lowercaseServiceName) {

    /*----- Page Sidebar -----*/
    case 'date':
    case 'days':
    case 'deadline':
      return <FaCalendarAlt />; // Calendar icon representing a date or deadline
  
    case 'time':
    case 'timing':
    case 'hours':
      return <FaClock />; // Clock icon representing time-related info

    case 'duration':
      return <FaClock />; // Clock icon representing time-related info

    case 'client':
    case 'position':
    case 'students':
      return <FaUsers />; // Users icon representing a group of people

    case 'category':
      return <FaTags />; // Tags icon representing category or skill level

    case 'skilllevel':
      return <FaGraduationCap />; // Tags icon representing category or skill level

    case 'location':
      return <FaMapMarkerAlt />; // Map Marker icon representing a location

    case 'price':
    case 'cost':
    case 'salary':
    case 'fee':
      return <FaDollarSign />; // Dollar sign icon representing cost or payment

    case 'experience':
      return <FaBriefcase />; // Award icon representing experience or achievement

    case 'projectlead':
    case 'instructor':
    case 'organizer':
      return <FaUserTie />; // User Tie icon representing an organizer or instructor

    case 'certificate':
      return <FaAward />; // Award icon representing certification

    case 'number':
      return <FaPhone />; // Phone icon representing contact number

    case 'email':
      return <FaEnvelope />; // Envelope icon representing an email address

    default:
      return null; // Return null if no matching icon is found
  }

};